import React from "react";
import { Drawer } from "antd";
import { useIsMobile } from "../../hooks/useMediaQuery";
import "./sheet.scss";

// Drop-in replacement for antd's Drawer: a side panel on tablet/desktop and a
// bottom sheet on phones. Accepts every Drawer prop unchanged.
const SheetDrawer = ({ placement = "right", width, rootClassName, ...props }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer
        {...props}
        placement="bottom"
        height="auto"
        rootClassName={["sheet sheet--bottom", rootClassName].filter(Boolean).join(" ")}
      />
    );
  }

  return (
    <Drawer
      {...props}
      placement={placement}
      width={width}
      rootClassName={["sheet sheet--side", rootClassName].filter(Boolean).join(" ")}
    />
  );
};

export default SheetDrawer;
